import {
  CertificateIcon,
  FolderOpenIcon,
  HandHeartIcon,
  HeartIcon,
  MedalIcon,
  NewspaperClippingIcon,
  QuotesIcon,
} from "@phosphor-icons/react";

import type { AdditionalBuilderStep } from "@/client/constants/builder-steps";

export const SECTION_CATALOG = [
  {
    id: "projects",
    name: "Projets",
    description: "Présentez vos réalisations et votre rôle.",
    icon: FolderOpenIcon,
  },
  {
    id: "certifications",
    name: "Certifications",
    description: "Valorisez vos compétences certifiées.",
    icon: CertificateIcon,
  },
  {
    id: "volunteer",
    name: "Bénévolat",
    description: "Montrez votre engagement et son impact.",
    icon: HandHeartIcon,
  },
  {
    id: "awards",
    name: "Récompenses",
    description: "Ajoutez vos prix et distinctions.",
    icon: MedalIcon,
  },
  {
    id: "interests",
    name: "Centres d’intérêt",
    description: "Partagez les activités qui vous définissent.",
    icon: HeartIcon,
  },
  {
    id: "publications",
    name: "Publications",
    description: "Référencez vos articles et ouvrages.",
    icon: NewspaperClippingIcon,
  },
  {
    id: "references",
    name: "Références",
    description: "Ajoutez vos recommandations professionnelles.",
    icon: QuotesIcon,
  },
] satisfies Array<{
  id: AdditionalBuilderStep;
  name: string;
  description: string;
  icon: typeof FolderOpenIcon;
}>;
